module.exports = __webpack_public_path__ + "media/images/costOfAbuse-graphic-lvl3-cecac8decade3b6061c06bce1ce62601.svg";